import React, {useEffect, useState, useRef, useContext} from "react";
import * as Survey from "survey-react";
import "survey-react/survey.css";
import { surveyService } from "../../services";
import { Skeleton, Modal, Button, notification,Spin } from 'antd';
import { GlobalContext } from "../../contexts/GlobalContext";
//import useWindowDimensions from "../../hooks/useWindowDimensions";
import "./SurveyViewer.css";
import {config} from "../../config"
import { UserContext } from "../../contexts/UserContext";
import { TypeaheadInputMulti } from "react-bootstrap-typeahead";
import {FinishedSurveyScreen} from "./FinishedSurveyScreen"
let resizebase64 = require('resize-base64');  



const SurveyViewer = ({surveyId, visible, onClose, onComplete,bigSurvey,surveyLoading}) => {
    const { location: userLocation } = useContext(UserContext)
    //const {width, height} = useWindowDimensions()
    const {successHandler, errorHandler, loading, setLoading } = useContext(GlobalContext)
    let model = null;
    const storageName = `ciklopark_saved_state_${surveyId}`;
    const surveyModelRef = useRef(null);
    const [selectedSurvey, setSelectedSurvey] = useState(null)
    const [isSaving, setIsSaving] = useState(false)
    const [finishedSurveyScreen, setFinishedSurveyScreen] = useState(false)

    const loadSelection = (survey) => {
        let storageSt = window
            .localStorage
            .getItem(storageName) || "";

        let res = {};
        if (storageSt) {
            res = JSON.parse(storageSt);
        }
    }

    const loadState = (survey) => {
        let storageSt = window
            .localStorage
            .getItem(storageName) || "";

        let res = {};
        if (storageSt) {
            res = JSON.parse(storageSt);

            if(survey) {
                //Set the loaded data into the survey.
                if (res.currentPageNo) {
                    survey.currentPageNo = res.currentPageNo;
                }
                    
                if (res.data) {
                    survey.data = res.data;
                    //survey.runTriggers();
                } 
            }
        }
    }

    const saveState = (survey) => {
        if(!survey) {
            
            return;
        }

        const res = {
            currentPageNo: survey.currentPageNo,
            data: survey.data
        };

        window
            .localStorage
            .setItem(storageName, JSON.stringify(res));
    }

    const addStandSelectionEvents = () => {
        //console.log("Add stand selection events", document.querySelectorAll('[data-name="bicycle_stand_type"] .sv-q-col-1'))
       
        
        document.querySelectorAll('[data-name="bicycle_stand_type"] .sv-q-col-1').forEach(e => {

            //console.log("Got element", e, e?.onClick)
            
            if(!e.onClick) {
                //console.log("Set on click", e)
                e.addEventListener('click', function (ev) {
                    //console.log("Click", ev, e)
                    e.querySelector('input').checked = true
                    //console.log(surveyModelRef.current.data)
                    surveyModelRef.current.setValue('bicycle_stand_type', e.querySelector('input').value)
                })
            }
            
        })
        document.querySelectorAll('[data-name="bicycle_stand_type_demand"] .sv-q-col-1').forEach(e => {            
            if(!e.onClick) {
                e.addEventListener('click', function (ev) {
                    e.querySelector('input').checked = true
                    surveyModelRef.current.setValue('bicycle_stand_type_demand', e.querySelector('input').value)
                })
            }
            
        })
        document.querySelectorAll('[data-name="type_of_demand"] .sv-q-col-1').forEach(e => {
            if(!e.onClick) {
                e.addEventListener('click', function (ev) {
                    e.querySelector('input').checked = true
                    surveyModelRef.current.setValue('type_of_demand', e.querySelector('input').value)
                })
            }
            
        })
        document.querySelectorAll('[data-name="bicycle_usage_parking_stand_type"] .sv-q-col-1').forEach(e => {            
            if(!e.onClick) {
                e.addEventListener('click', function (ev) {
                    e.querySelector('input').checked = true
                    surveyModelRef.current.setValue('bicycle_usage_parking_stand_type', e.querySelector('input').value)
                })
            }
            
        })

        document.querySelectorAll('[data-name="bicycle_usage_parking_optimal_type_of_stand"] .sv-q-col-1').forEach(e => {            
            if(!e.onClick) {
                e.addEventListener('click', function (ev) {
                    e.querySelector('input').checked = true
                    surveyModelRef.current.setValue('bicycle_usage_parking_optimal_type_of_stand', e.querySelector('input').value)
                })
            }
            
        })

        var arr = []
        document.querySelectorAll('[data-name="bicycle_usage_parking_type_replacement"] .sv-q-col-1').forEach(e => {
            if(!e.onClick) {
                e.addEventListener('click', function (ev) {
                    var input = e.querySelector('input').value
                    // add unique input value to the array
                    if(arr.indexOf(input) === -1) {
                        arr.push(input)
                    }
                    else {
                        arr = arr.filter(e => e !== input)
                    }
                    surveyModelRef.current.setValue('bicycle_usage_parking_type_replacement', arr)
                    console.log(arr)
                })
            }
        })
    }


    useEffect(() => {
        
        const fetchData = async () => {
            setLoading(true)
            try {
                const response = await surveyService.getSurvey(surveyId)
                const JLS = await surveyService.getRouterJLS()

                const counties = await surveyService.getCounties()
                
                const survey = response?.length && response[0].title
                if(survey) {
                    survey.completeText = "Završi anketu";
                    if(survey.pages[0].elements[0].name=="jls_pick"){
                        survey.pages[0].elements[0].choices=JLS.map(fs => ({value:fs.name, text:fs.name}))    
                    }

                    if(surveyId == 6) {
                        survey.pages[0].elements[0].choices = counties.map(fs => ({value:fs.id, text:fs.name}))
                        survey.triggers = [
                            {
                                type: "runexpression",
                                expression: "{county_pick} notempty",
                                runExpression: "getJLSFromCounties({county_pick}, 'jls_pick')"
                            },
                            {
                                type: "runexpression",
                                expression: "{jls_pick} notempty",
                                runExpression: "getSettlementsFromJLS({jls_pick}, 'settlement_pick')"
                            },
                        ]
                    }


                    setSelectedSurvey(survey)
                    if(selectedSurvey) {
                        model = new Survey.Model(selectedSurvey);
                        loadState(model)
                
                        model.onCurrentPageChanged
                            .add((survey, options) => {
                                saveState(survey);
                            });

                        model.onAfterRenderQuestion
                        .add(function (sender, options) {
                            if(options.question.getType() === "file") {
                                var input = options.htmlElement.querySelector("input");
                                input.capture = "camera";
                            }
                        });


                       
                        surveyModelRef.current = model;
                
                        /*
                        clearInterval(timerId)
                        timerId = window.setInterval(function () {
                            saveState(model);
                        }, 15000);
                        */
                    }
                    loadSelection(model)
                }
            }
            catch(error) {
                console.error("Error while loading survey:", error?.response)
                errorHandler("Pogreška prilikom učitavanja ekrana")
                
            }
            finally {
               setLoading(false)
            }
        }

        if(visible) {
            fetchData()
        }

        

    }, [visible])

    if(selectedSurvey) {
        model = new Survey.Model(selectedSurvey);
        loadState(model)

        model.onCurrentPageChanged
        .add((survey, options) => {
            saveState(survey);
        });

        model.onAfterRenderQuestion
        .add(function (sender, options) {           
            if(options.question.getType() === "file") {
                let cameraFunction = options.htmlElement.querySelector("input");
                let cameraIcon = options.htmlElement.querySelector(".sv_q_file_choose_button");
                let removePlaceholderText = options.htmlElement.querySelector(".sv_q_file_placeholder");                
                cameraFunction.capture = "camera";
                cameraIcon.innerHTML="<li class='fa enlargePhotoIcon' >&#xf030;</li>"
                if(removePlaceholderText){
                removePlaceholderText.innerHTML=""        
                }  
            }
        });

        model.onValueChanged
        .add(function (sender, options) {
            if(options.question.getType() === "dropdown") {
                
                if(options.name=="county_pick" &&model.data&& model.data.jls_pick && !model.data.delivery_service_importance){
                    let county_pick=options.value
                    model.data={county_pick}
                }
                else if(options.name=="jls_pick"&&model.data&& model.data.settlement_pick && !model.data.delivery_service_importance){
                    let county_pick=model.data.county_pick
                    let jls_pick=model.data.jls_pick
                    model.data={county_pick ,jls_pick}
                }
                
            }
        });

        model.onValueChanged.add(function(sender,options){
            if(options.name == "county_pick") {
              const element = document.getElementById('bottomSurveyElement');
              if(element){
              element.scrollIntoView();
              window.scrollBy(0, -100)}
            } 
            else if(options.name == "jls_pick"){
                const element = document.getElementById('bottomSurveyElement');
                if(element){
                element.scrollIntoView();
                window.scrollBy(0, -100)
            }
            }           
          });
          
        
        model.onAfterRenderQuestion  
        .add(addStandSelectionEvents) 
        
     
        surveyModelRef.current = model;

        /*
        clearInterval(timerId)
        timerId = window.setInterval(function () {
            saveState(model);
        }, 15000);
        */
    }



 
    
    //Survey.FunctionFactory.Instance.register("getMunicipalityCityFromCounty", getMunicipalityCityFromCounty);
    Survey.locale = "hr";
    
    const handleComplete = async (survey, options) => {
        setIsSaving(true)
        if(survey.data&&survey.data.photo){
            let temporaryPhotoData=resizebase64(survey.data.photo[0].content, 1024, 600);         
            survey.data.photo[0].content=temporaryPhotoData
            }
        else if(survey.data&&survey.data.photo_alternative_demand){
                let temporaryPhotoData=resizebase64(survey.data.photo_alternative_demand[0].content, 1024, 600);        
                survey.data.photo_alternative_demand[0].content=temporaryPhotoData        
            }
        else if(survey.data&&survey.data.photo_existing_demand){
                let temporaryPhotoData=resizebase64(survey.data.photo_existing_demand[0].content, 1024, 600);        
                survey.data.photo_existing_demand[0].content=temporaryPhotoData        
            }
        try {
            if(bigSurvey){         
                console.log("Successfully answered the big survey")    
                await surveyService.saveAnswer({
                     details: JSON.stringify(survey.data),
                     x: 0,
                     y: 0,
                     idcontrols:surveyId,
                 })
            }
            else{
                console.log("Successfully answered the regular survey")
                await surveyService.saveAnswer({                
                    details: JSON.stringify(survey.data),
                    //"x" : Math.random()*4.1 + 42.4, // 45.2 - 45.7
                    //"y": Math.random()*6 + 13.46, // 15.7 - 18.7
                    y: userLocation.coords.longitude,
                    x: userLocation.coords.latitude,
                    idcontrols:surveyId,
                })
            }
            window.localStorage.removeItem(storageName);
            if(surveyId==4){                
            successHandler(`Uspješno ste prijavili potražnju, vaša prijava će biti provjerena i potencijalno odobrena unutar 24 sata.`)
            }
            else if(surveyId==2 ||surveyId==3 ||surveyId==5){
                
            successHandler("Uspješno ste prijavili ponudu, vaša prijava će biti provjerena i potencijalno odobrena unutar 24 sata")
            }
            setFinishedSurveyScreen(true)
            onClose()
           
        }
        catch(error) {
            if(!userLocation){
                console.debug("No user location")
            }
            else{
                console.debug("The sent data",survey.data)
                console.debug("Longitude",userLocation.coords.longitude)
                console.debug("Latitude",userLocation.coords.latitude)
                console.debug("surveyId",surveyId)
                console.error("Error while saving response:", error)
                errorHandler("Dogodila se pogreška, pokušajte ponovno")
            }
        }
        finally {
            setIsSaving(false)
        }
    }

    const finishSurvey = () => {
        //console.log("Got user location:", userLocation, config.getUser())
        if(!userLocation){
            onClose()
            errorHandler("Došlo je do pogreške pri dohvačanju vaše lokacije,molimo vas dopustite slanje lokacije i osvježite preglednik.")
        }
        if(!loading && !selectedSurvey) {
            onClose()
            return
        }
        const survey = surveyModelRef?.current
        if(survey) {
            survey.completeLastPage()
        }
        
    }

    const getJLSFromCounties = async (params) => {
        const search = params[0];
        const target = params[1];

        const data = await surveyService.getJLS(search);
        model.getQuestionByName(target).choices = data.map(fs => ({value:fs.id, text:fs.name}));
        /*
        const filteredSettlements = settlements.filter(s => s.governmentUnitName == search).map(fs => ({value:fs.name, text:fs.name}));
        model.getQuestionByName(target).choices = filteredSettlements;*/
    }

    const getSettlementsFromJLS = async (params) => {
        const search = params[0];
        const target = params[1];

        const data = await surveyService.getSettlements(search);
        model.getQuestionByName(target).choices = data.map(fs => ({value:fs.id, text:fs.name}));

        /*
        const filteredSettlements = settlements.filter(s => s.governmentUnitName == search).map(fs => ({value:fs.name, text:fs.name}));
        model.getQuestionByName(target).choices = filteredSettlements;*/
    }

    Survey.FunctionFactory.Instance.register("getJLSFromCounties", getJLSFromCounties);
    Survey.FunctionFactory.Instance.register("getSettlementsFromJLS", getSettlementsFromJLS);
    Survey.locale = "hr";

    return (<>
        {bigSurvey&&<>
        {loading && <Skeleton active />}
            {!loading && selectedSurvey && (
                <Survey.Survey model={model} locale="hr" onComplete={handleComplete} />
            )}
            {!loading && !selectedSurvey && (
                <div>Greška prilikom dohvata podataka</div>
            )}
           {finishedSurveyScreen&&(
           
            <FinishedSurveyScreen
             >
           
            </FinishedSurveyScreen>
            
           )}
            </>}
        {!bigSurvey &&
        <Modal
            bodyStyle={{overflowY: 'scroll'}}
            className={`survey-modal`}
            visible={visible} 
            open={visible}
            onCancel={onClose}  
            footer={[
             <div className="survey-viewer__footer">
                <Button key="submit" className="c-btn" disabled={loading} loading={isSaving} onClick={finishSurvey}>
                    {!loading && !selectedSurvey && "Zatvori" || 'Pošalji'}
                </Button>
             </div> 
            ]}
        >
            {surveyLoading&&<><h1 className="survey-viewer__loading-text">Postavljanje preciznije lokacije u tijeku, molimo pričekajte...</h1>
            <Spin size="large" className="survey-viewer__loading-spinner"/></>}
            {!surveyLoading&&loading && <Skeleton active round title={{width:'100%'}} paragraph={{rows: 30}} avatar />}
            {!surveyLoading&&!loading && selectedSurvey && (
                <Survey.Survey model={model} locale="hr" onComplete={handleComplete} />
            )}
            {!surveyLoading&&!loading && !selectedSurvey && (
                <div>Greška prilikom dohvata podataka</div>
            )}
        </Modal>
}
        </>
    )
}

export default SurveyViewer;